export default function SchematicsDirective() {
  return {
    template: require('./schematics.html'),
    scope: {
      customerId: '=',
      assessmentId: '=',
      mainOfficeSchematics: '=',
      branchSchematics: '=',
      disasterRecoverySchematics: '=',
      addCallback: '&',
      deleteCallback: '&',
      status: '=',
      tooltipAppendToSelector: '@',
    },
    controller: 'SchematicsController',
    controllerAs: 'schematicsVM',
    bindToController: true,
    replace: true,
  };
}
